import { MeasureUnitValues } from 'src/services/tasks/constants';
import store from 'src/store';
import { setRequirementFormErrors } from 'src/store/createNewJobSlice';

/**
 * Find if a task has an error.
 */
export const doesTaskHaveError = (taskName: string) => {
  const requirementFormErrors = store.getState().createNewJobPage.requirementFormErrors;
  return requirementFormErrors[taskName] && Object.values(requirementFormErrors[taskName]).some((rfe) => rfe.error);
};

/**
 * Find if any tasks have errors
 */
export const doTasksHaveErrors = () => {
  const taskNames = store.getState().createNewJobPage.jobFormData.tasks.map((t) => t.label!);
  return taskNames.some((t) => doesTaskHaveError(t));
};

/**
 * Validate all tasks
 */
export const validateTasks = () => {
  const jobFormData = store.getState().createNewJobPage.jobFormData;
  const newErrors: any = {};
  let isValid = true;
  if (jobFormData) {
    for (const task of jobFormData.tasks) {
      const requirementNameError = validateRequirementValue(task.measureUnit as string, task.requirementName as string);
      newErrors[task.label as string] = {
        requirementName: {
          error: requirementNameError ? true : false,
          errorMessage: requirementNameError,
        },
      };
      if (!task.requirementName) {
        isValid = false;
      }
    }
  }
  store.dispatch(setRequirementFormErrors(newErrors));
  return isValid;
};

/**
 * Validate requirement value
 */
export const validateRequirementValue = (measureUnit: string, requirementName: string) => {
  if (!requirementName) {
    return 'Requirement value is required';
  }
  if (measureUnit === MeasureUnitValues.Hours) {
    if (isNaN(+requirementName) || +requirementName > 1 || +requirementName < 0) {
      return 'Requirement value must be a number between 0 and 1';
    }
  } else if (measureUnit !== MeasureUnitValues.Bool) {
    if (isNaN(+requirementName) || +requirementName < 0) {
      return 'Requirement value must be an number greater than 0';
    }
  }
};

/**
 * Create right placeholder for requirement value given measure unit
 */
export const generatePlaceholderForRequirementName = (measureUnit: string | undefined) => {
  if (!measureUnit) {
    return 'Select a success criteria to enter a requirement value';
  } else if (measureUnit === 'Hours') {
    return 'Enter % of shift required between 0-1...';
  } else {
    return 'Enter a positive number...';
  }
};
